import { idStateDocumentWizard } from 'civil-status/constants/id-state-document-wizard';
import { DocumentVM, LastStepVM, ParentVM } from 'civil-status/view-models/step-form';

export const isDisabledValid = (
  isLastStep: boolean, // Indica se è l'ultimo passo
  withErrors: boolean, // Indica se ci sono errori
  castedValues?: LastStepVM, // Valori dell'ultimo passo
  keyWithTwins?: string, // chiave del soggetto per la gestione dei gemelli
  isLastStepEmergency?: boolean
): boolean => {
  // Se non è l'ultimo passo, il pulsante è disabilitato
  if (!isLastStep) {
    return true;
  }

  // Se ci sono errori, il pulsante è disabilitato
  if (withErrors) {
    return true;
  }

  const document = castedValues.document as DocumentVM;

  // Se ci sono documenti non ancora verificati, il pulsante è disabilitato
  if (
    (document?.files?.filter((item) => item.codStato !== idStateDocumentWizard.Inserito) || [])
      ?.length > 0 &&
    !isLastStepEmergency
  ) {
    return true;
  }

  // Se ci sono documenti obbligatori, il pulsante è disabilitato
  if ((document?.obligatoryFilesCurrent || [])?.length > 0) {
    return true;
  }

  // se c'è l'oggetto per la gestione dei gemelli si abilita se sono stati prenotati
  if (keyWithTwins && castedValues) {
    return !(castedValues[keyWithTwins] as ParentVM)?.generality?.isBookTwins;
  }

  // Altrimenti, il pulsante è abilitato
  return false;
};
